export default class MapProgress {
    el: any;
    loading: number;
    loaded: number;
    constructor(el: any) {
        this.el = el;
        this.loading = 0;
        this.loaded = 0;
    }
    /**
     * Increment the count of loading tiles.
     */
    addLoading() {
        ++this.loading;
        this.update();
    }
    /**
     * Increment the count of loaded tiles.
     */
    addLoaded() {
        ++this.loaded;
        this.update();
    }
    /**
     * Update the progress bar.
     */
    update() {
        const width = ((this.loaded / this.loading) * 100)?.toFixed(1)?.toString() + '%';
        this.el.style.width = width;
    }
    /**
     * Show the progress bar.
     */
    show() {
        this.el.style.visibility = 'visible';
    }
    /**
     * Hide the progress bar.
     */
    hide() {
        const style = this.el.style;
        setTimeout(function () {
            style.visibility = 'hidden';
            style.width = 0;
        }, 250);
    }
}

export function applyMapLoaderForLayer(mapLoader: any, layer: any) {
    const progress = new MapProgress(mapLoader);
    layer.getSource().on('tileloadstart', () => {
        progress.addLoading();
    })
    layer.getSource().on('tileloadend', () => {
        progress.addLoaded();
    })
}

export function applyMapLoaderForMap(mapLoader: any, map: any) {
    const progress = new MapProgress(mapLoader);
    map.on('loadstart', (e: any) => {
        progress.show()
    });
    map.on('loadend', (e: any) => {
        progress.hide()
    });
}